import { ComponentPropsWithoutRef } from 'react'

import { cn } from '@/theme/utils'

export default function UiContainer({
  className,
  ...rest
}: ComponentPropsWithoutRef<'div'>) {
  return (
    <div {...rest} className={cn('mx-auto w-full max-w-[1376px]', className)} />
  )
}
